module.exports = __webpack_public_path__ + "media/landing_parts/icons/classlink-e64ea2241a7c15cc9aab9876de555281.png";